import { PersonalCodeResult } from '@app/lib/personal-code/model/PersonalCodeResult';

function isValidDate(year: number, month: number, day: number): boolean {
    const date = new Date(year, month - 1, day);
    return date.getFullYear() === year && date.getMonth() === month - 1 && date.getDate() === day;
}

function calculateChecksum(digits: number[]): number {
    const weights = [1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
    const sum = digits.slice(0, 10).reduce((acc, digit, i) => acc + digit * weights[i], 0);
    return ((1101 - sum) % 11) % 10;
}

function isNewFormat(digits: number[]): boolean {
    return digits[0] === 3 && digits[1] >= 2;
}

export function parseLatvianPersonalCode(personalCode: string): PersonalCodeResult {
    const normalized = personalCode.replace(/-/g, '');

    if (!/^\d{11}$/.test(normalized)) {
        return { isValid: false };
    }

    const digits = normalized.split('').map(Number);

    if (calculateChecksum(digits) !== digits[10]) {
        return { isValid: false };
    }

    if (isNewFormat(digits)) {
        return { isValid: true };
    }

    const day = digits[0] * 10 + digits[1];
    const month = digits[2] * 10 + digits[3];
    const yearShort = digits[4] * 10 + digits[5];
    const centuryDigit = digits[6];

    let century: number;
    switch (centuryDigit) {
        case 1:
            century = 1900;
            break;
        case 2:
            century = 2000;
            break;
        default:
            return { isValid: false };
    }

    const fullYear = century + yearShort;

    if (!isValidDate(fullYear, month, day)) {
        return { isValid: false };
    }

    const monthStr = normalized.substring(2, 4);
    const dayStr = normalized.substring(0, 2);
    const birthDate = `${fullYear}-${monthStr}-${dayStr}`;
    const today = new Date();
    const birthDateObj = new Date(fullYear, month - 1, day);
    let age = today.getFullYear() - birthDateObj.getFullYear();
    const monthDiff = today.getMonth() - birthDateObj.getMonth();

    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDateObj.getDate())) {
        age--;
    }

    return {
        isValid: true,
        year: fullYear,
        age,
        birthDate,
    };
}
